import { render, staticRenderFns } from "./mingJiaLangDu.vue?vue&type=template&id=ba0e1666&scoped=true&"
import script from "./mingJiaLangDu.vue?vue&type=script&lang=js&"
export * from "./mingJiaLangDu.vue?vue&type=script&lang=js&"
import style0 from "./mingJiaLangDu.vue?vue&type=style&index=0&id=ba0e1666&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0e1666",
  null
  
)

export default component.exports